import { useState, useEffect, useRef } from "react";
import { Modal, Card } from 'react-bootstrap';

const HtmlPreview = ({ product, adors }) => {

  // const { editor, onReady } = useFabricJSEditor()
  const myCanvas = useRef(null);
  const [lastAdorImg, setLastAdorImg] = useState();
  
  // Drawing adors elements on to a canvas
  useEffect(() => {
    const ctx = myCanvas.current.getContext('2d');
    const bg = new Image();
    bg.src = `/sees/dist/img/products/${product.id}.jpg`;
    bg.onload = () => { drawBgImage(bg, ctx); }
  }, [product.id]);

  // Drawing adors elements on to a canvas
  const drawBgImage = (img, ctx) => {
    let canvas = ctx.canvas;
    let hRatio = canvas.width / img.width;
    let vRatio = canvas.height / img.height;
    let ratio = Math.min(hRatio, vRatio);
    let translate_x = (canvas.width - img.width * ratio) / 2;
    let translate_y = (canvas.height - img.height * ratio) / 2;

    // ctx.clearRect(0, 0, canvas.width, canvas.height);
    // For jpeg white background
    ctx.fillStyle = "#FFFFFF";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.drawImage(img,
      0, 0, img.width, img.height,
      translate_x, translate_y, img.width * ratio, img.height * ratio);
  }

  return (
    <div className="card" >
      <div className="card-body">
        <canvas ref={myCanvas} id="my-canvas" className="w-100"></canvas>
      </div>
    </div>
  );

}

export default HtmlPreview;